import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import { SiLocalizationService } from '@simpl/siemens-brand-localize';

class SiLocalizationNgService extends SiLocalizationService {
    constructor() {
        super(...arguments);
        this.translations = {
            'si-toast.close.aria-label': () => $localize `:@@si-toast.close.aria-label:Close message`,
            'si-dropdown.clear.aria-label': () => $localize `:@@si-dropdown.clear.aria-label:Clear`,
            'si-table.column.sort-desc.aria-label': params => $localize `:@@si-table.column.sort-desc.aria-label:Sort by ${params?.name} descending`,
            'si-table.column.sort-asc.aria-label': params => $localize `:@@si-table.column.sort-asc.aria-label:Sort by ${params?.name} ascending`,
            'si-pagination.fast-backward.aria-label': () => $localize `:@@si-pagination.fast-backward.aria-label:Fast backward`,
            'si-pagination.backward.aria-label': () => $localize `:@@si-pagination.backward.aria-label:Backward`,
            'si-pagination.page.aria-label': params => $localize `:@@si-pagination.page.aria-label:Page ${params?.page} of ${params?.total}`,
            'si-pagination.forward.aria-label': () => $localize `:@@si-pagination.forward.aria-label:Forward`,
            'si-pagination.fast-forward.aria-label': () => $localize `:@@si-pagination.fast-forward.aria-label:Fast forward`,
            'si-breadcrumb.aria-label': () => $localize `:@@si-breadcrumb.aria-label:Breadcrumb`,
            'si-breadcrumb.home.aria-label': () => $localize `:@@si-breadcrumb.home.aria-label:Home`,
            'si-dropdown.option.select.all': () => $localize `:@@si-dropdown.option.select.all:Select all`,
        };
    }
    translate(key, params) {
        return this.translations[key](params);
    }
}
SiLocalizationNgService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: SiLocalizationNgService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
SiLocalizationNgService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: SiLocalizationNgService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: SiLocalizationNgService, decorators: [{
            type: Injectable
        }] });

class SiLocalizationNgModule {
}
SiLocalizationNgModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: SiLocalizationNgModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SiLocalizationNgModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.4", ngImport: i0, type: SiLocalizationNgModule });
SiLocalizationNgModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: SiLocalizationNgModule, providers: [
        { provide: SiLocalizationService, useClass: SiLocalizationNgService },
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: SiLocalizationNgModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        { provide: SiLocalizationService, useClass: SiLocalizationNgService },
                    ],
                }]
        }] });

/*
 * Public API Surface of siemens-brand-localize-with-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SiLocalizationNgModule, SiLocalizationNgService };
